(() => {
  const hero = document.querySelector('[data-kaw-hero]');
  if (!hero) return;

  const controller = new AbortController();
  const { signal } = controller;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const getScroller = () => {
    const wrapper = document.querySelector('.page-wrapper');
    if (wrapper && wrapper.scrollHeight > wrapper.clientHeight) return wrapper;
    return document.scrollingElement;
  };

  let scrollFrame = 0;

  const animateScrollTo = (target) => {
    if (!target) return;
    cancelAnimationFrame(scrollFrame);
    const scroller = getScroller();
    const destination = target.getBoundingClientRect().top + scroller.scrollTop;
    scroller.style.scrollBehavior = 'auto';
    if (reduced) {
      scroller.scrollTop = destination;
      scroller.style.scrollBehavior = '';
      return;
    }
    const start = scroller.scrollTop;
    const distance = destination - start;
    const duration = 2000;
    const t0 = performance.now();
    const swing = (t) => 0.5 - Math.cos(t * Math.PI) / 2;
    const step = (now) => {
      const progress = Math.min((now - t0) / duration, 1);
      scroller.scrollTop = start + distance * swing(progress);
      if (progress < 1) {
        scrollFrame = requestAnimationFrame(step);
      } else {
        scroller.style.scrollBehavior = '';
      }
    };
    scrollFrame = requestAnimationFrame(step);
  };

  const cue = hero.querySelector('[data-kaw-scroll-cue]');
  if (cue) {
    cue.addEventListener(
      'click',
      () => animateScrollTo(document.querySelector('.kaw-category-tiles-section')),
      { signal }
    );
  }

  const dots = [...hero.querySelectorAll('[data-kaw-dot-target]')];
  dots.forEach((dot) => {
    dot.addEventListener(
      'click',
      () => {
        const target = document.querySelector(dot.dataset.kawDotTarget);
        dots.forEach((d) => d.classList.remove('is-active'));
        dot.classList.add('is-active');
        animateScrollTo(target);
      },
      { signal }
    );
  });

  window.addEventListener('pagehide', () => controller.abort(), { signal });
})();
